import {useEffect} from 'react';

function getTabs(tablist: Element): HTMLElement[] {
    return Array.from(
        tablist.querySelectorAll<HTMLElement>('[role="tab"], .g-tabs__tab, .g-tabs__item')
    ).filter((tab) => !tab.hasAttribute('disabled') && tab.getClientRects().length > 0);
}

export function useTabsKeyboard() {
    useEffect(() => {
        const onKeyDown = (event: KeyboardEvent) => {
            if (event.key !== 'Tab' || !event.ctrlKey || event.altKey || event.metaKey) {
                return;
            }

            const target = event.target;

            if (!(target instanceof HTMLElement)) {
                return;
            }

            const tablist = target.closest('[role="tablist"], .g-tabs');

            if (!tablist) {
                return;
            }

            const tabs = getTabs(tablist);

            if (tabs.length < 2) {
                return;
            }

            const current =
                tabs.find((tab) => tab === target || tab.contains(target)) ??
                tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') ??
                tabs[0];
            const index = Math.max(tabs.indexOf(current), 0);
            const nextIndex = event.shiftKey
                ? (index - 1 + tabs.length) % tabs.length
                : (index + 1) % tabs.length;
            const next = tabs[nextIndex];

            event.preventDefault();
            next.focus();
            next.click();
        };

        document.addEventListener('keydown', onKeyDown);

        return () => {
            document.removeEventListener('keydown', onKeyDown);
        };
    }, []);
}
